module.exports = __webpack_public_path__ + "media/images/ours_fav_big_dev-5d973f515ec9cf52e4545992f840ae37.png";